import {
	nodeBundles as customNodeBundles, 
	entityTypes as customEntityTypes
} from '../../conf/entityAdmin'
import {createPermission} from '../lib/auth'
import auth from '../../authorize'

const nodeBundles = Object.assign({
	'page': {
		name: 'Pagină',
	},
	'template': {
		name: 'Template',
		pathinfo: '/templates',
	}
	
}, customNodeBundles)

const entityTypes = Object.assign({
	/*
	'region': {
		name: 'Regiune',
	},
	
	frag: {
		name: 'Fragment',
	}
	*/
}, customEntityTypes)

const entityAccess = (user, op, data) => {
	if (!op || !data) return false
	if (!user) return false
	//if (isEditor()) return true
	
	switch (op) {
		case 'create': {
			if (!auth.entity[data] || !auth.entity[data].create) return false
			let authRoles = auth.entity[data].create

			let ret = false
			user.roles.forEach(role => {
				if (authRoles.includes(role)) ret = true
			})
			return ret
		}
		case 'update': {
			const entity = data
			let type = entity.type==='node'
				?entity.bundle
				:entity.type
			if (!type) return false
			if (!auth.entity[type] || !auth.entity[type].update) return false
			let authRoles = auth.entity[type].update
			
			let ret = false
			user.roles.forEach(role => {
				if (authRoles.includes(role)) ret = true
			})
			return ret
		}
		case 'delete': {
			const entity = data
			let type = entity.type==='node'
				?entity.bundle
				:entity.type
			if (!type) return false
			if (!auth.entity[type] || !auth.entity[type].delete) return false
			let authRoles = auth.entity[type].delete
			
			let ret = false
			user.roles.forEach(role => {
				if (authRoles.includes(role)) ret = true
			})
			return ret
		}
		default:
			return false
	}
}
createPermission('create', {cb: entityAccess})
createPermission('update', {cb: entityAccess})
createPermission('delete', {cb: entityAccess})

export {nodeBundles, entityTypes}



// WEBPACK FOOTER //
// ./src/fm/conf/entityAdmin.js